<div class="row" [style.background-color]="site['theme']['headerBackgroundColor']">
  <div class="col-sm-12">
      <header [class.with-logo]="showLogo">
          <!-- Back button injection -->
          <ng-content></ng-content>

          <!-- Show the logo if no back button and we have a logo -->
          <ng-container *ngIf="!showBackButton && showLogo">
              <a *ngIf="site.settings.homepageUrl && site['theme']['logo'] && showLogo" (click)="clickEvent.emit('cp_home_button')" [href]="site.settings.homepageUrl" target="_blank">
                  <img [src]="site['theme']['logo']['url']" [alt]="site['theme']['logo']['altText']">
              </a>
              <img *ngIf="!site.settings.homepageUrl && site['theme']['logo'] && showLogo" [src]="site['theme']['logo']['url']" [alt]="site['theme']['logo']['altText']">
          </ng-container>

          <!-- Show the Home button if homepageUrl is set and no logo -->
          <ng-container *ngIf="!showBackButton && !showLogo">
              <a *ngIf="site.settings.homepageUrl" (click)="clickEvent.emit('cp_home_button')" [href]="site.settings.homepageUrl" target="_blank">
                  <button class="header-button" OnHoverDarken [style.backgroundColor]="site['theme']['buttonColor']" [color]="site['theme']['buttonColor']">Home</button>
              </a>
          </ng-container>

          <!-- Header links -->
          <div *ngIf="headerLinks.length > 0"  class="header-links">
              <customer-links-menu [links]="headerLinks" (closeMenu)="openMobileLinks=false"></customer-links-menu>
          </div>
          <button *ngIf="headerLinks.length > 0" type="button" class="header-links-mobile-button" [class.is-active]="openMobileLinks" (click)="openMobileLinks = !openMobileLinks" >
              <span class="hamburger-box">
                  <span class="hamburger-inner"></span>
                </span>
          </button>

          <!-- Job search button -->
          <div class="search-button"
            *ngIf="showSearchJobs"
            [style.background-color]="site['theme']['headerBackgroundColor']"
            [ngClass]="{ 'has-menu-links': headerLinks.length > 0 }"
            (click)="searchJobs.emit()"
          ><i class="icon icon-search"></i>Search Jobs</div>
      </header>
  </div>
</div>

<!-- Header links mobile menu -->
<div *ngIf="headerLinks.length > 0"  class="header-links--mobile">
    <customer-links-menu [links]="headerLinks" [showAsDropdown]="true" [open]="openMobileLinks" [themeColor]="site['theme']['color']" (closeMenu)="openMobileLinks=false"></customer-links-menu>
</div>
